import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, QueryList, ViewChild, ViewChildren, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {DSTFormState, StmtAttrData, StmtData} from '../../../../../shared/models/dst-form-state.model';
import {TrackerTabsService, TrackerTabState} from '../../../../tracker-tabs.service';
import {CreateDisclosureSharedService, EntityNameChange} from '../../create-disclosure-shared.service';
import {DSTSavePayload} from '../../dst-dynamic-component-resolver.service';
import {DSTConsolGroup, TemplateHeaderComponent} from '../template-header/template-header.component';
import {TemplateHeaderService} from '../template-header/template-header.service';
import {DSTEntityDetails, TemplateLeidSelectorComponent} from '../template-leid-selector/template-leid-selector.component';
import {DSTSharedService} from '../../../../../shared/dst-shared.service';
import { HttpErrorResponse } from '@angular/common/http';
import {toSaveString, safeEntityId} from '../../dst-save.util';

@Component({
    selector: 'dst-template-sec367b-id194',
    templateUrl: './template-sec367b-id194.component.html',
    styleUrls: ['../template-shared.scss', './template-sec367b-id194.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TemplateSec367bId194Component implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);


  @ViewChild(TemplateHeaderComponent)
  private headerComponent!: TemplateHeaderComponent;

  @ViewChildren(TemplateLeidSelectorComponent)
  private leidComponents!: QueryList<TemplateLeidSelectorComponent>;

  @Output('onSave') onSave: EventEmitter<DSTSavePayload> = new EventEmitter<DSTSavePayload>();
  @Output('onCancel') onCancel: EventEmitter<null> = new EventEmitter<null>();

  form194!: UntypedFormGroup;
  selectedOptionID!: Event;
  dcnId!: number;
  startLoader: boolean = false;
  statementId: string = '';
  attMap: { [key: string]: string[] } = {};
  editMode: boolean = false;
  beginDate!: Date;
  endDate!: Date;
  transferor!: DSTEntityDetails | null;
  transferee!: DSTEntityDetails | null;
  branchEntity!: DSTEntityDetails | null;
  AdoptedDate: any = '';
  showDREMsg: boolean = false;
  DREMsg: string = '';
  entityNameChangeOnDate: boolean = false;
  OwnedPctVal : string = '';
  ownedPctField:boolean = false;
    nameChangeChecked: boolean = false;

  constructor(private formBuilder: UntypedFormBuilder,
              private dstSharedService: DSTSharedService,
              private sharedService: CreateDisclosureSharedService,
              private headerService: TemplateHeaderService,
              private trackerTabsService: TrackerTabsService,
              private cdref: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.editMode = false;
    this.beginDate = new Date(1700, 0, 1);
    this.endDate = new Date((this.sharedService.getActiveFormState()?.taxYear || 2021) + 2, 11, 31);
    let taxYear = this.sharedService.getActiveFormState()?.taxYear;
    if (taxYear>= 2023){
       this.ownedPctField = true;
       this.OwnedPctVal='';
    }else{
      this.ownedPctField = false;
    }
    this.form194 = this.formBuilder.group({
      header: this.formBuilder.group({
        consolGroup: ['', Validators.required],
        options: ['']
      }),
      main: this.formBuilder.group({
        AdoptedDate: [''],
        OwnedPctVal:[''],
      }),
    });
    if (this.sharedService.getFormStateByFormId(194)?.isChild) {
      this.sharedService.getLoadStatementData(194).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: StmtData) => {
        this.sharedService.setFormData(data, 194);
        this.loadStmtData();
      }, (eMsg: string) => {
        console.log(eMsg);
        this.dstSharedService.showAlert('error', eMsg);
      });
    } else {
      this.loadStmtData();
    }
  }

  ngAfterViewInit(): void {
  }

  private loadStmtData(): void {
    const data: StmtData | undefined = this.sharedService.getFormData(194);
    if (data) {
      this.statementId = data.isCopiedStatement ? '' : data.statementid.toString();
      this.dcnId = parseInt(data.dcnid!);
      this.editMode = true;
      this.populateFields(data);
      setTimeout(() => {
        this.leidComponents.toArray().forEach((element: TemplateLeidSelectorComponent, index: number) => {
          switch (index) {
            case 0:
              element.fillLEID(data.secondaryleid);
              break;
            case 1:
              element.fillLEID(data.primaryleid);
              break;
            case 2:
              if (data.branchleid) {
                element.fillLEID(data.branchleid);
              }
              break;
          }
        });
      },1000);
    } else if (this.sharedService.leid !== '') {
      this.statementId = (this.trackerTabsService.getActiveTrackerTab()?.getActiveFormState().statementId!).toString();
      const formId = this.sharedService.getActiveFormState().formId;
      const taxYear = (this.sharedService.getActiveFormState()?.taxYear || 2020).toString();
      const cseId = this.sharedService.getActiveFormState().cseId;

      setTimeout(() => {
        this.leidComponents.toArray()[1].fillLEID(this.sharedService.leid);
      });

      this.startLoader = true;
      this.sharedService.getDSTTrackerRequirementData(taxYear, cseId, formId!).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: StmtData) => {
        data && this.populateFields(data);
      }, () => { this.startLoader = false; }, () => { this.startLoader = false; });
    }else{
      this.nameChangeChecked = true;
    }
  }

  populateFields(data: StmtData): void {
    data.children?.forEach((stmt: StmtAttrData) => {
      if (this.attMap[stmt.attributeName] == undefined) {
        this.attMap[stmt.attributeName] = [];
      }
      if (stmt.attributeValue != null) {
        this.attMap[stmt.attributeName].push(stmt.attributeValue);
      }
    });
    if (this.attMap['AdoptedDate'] && this.attMap['AdoptedDate'][0] && this.attMap['AdoptedDate'][0] !== '') {
      this.AdoptedDate = new Date(this.attMap['AdoptedDate'][0].replace(/-/g, '\/').replace(/T.+/, ''));
    }
    if (this.attMap['f367bOwnedPct'] && this.attMap['f367bOwnedPct'][0]) {
      this.OwnedPctVal = this.attMap['f367bOwnedPct'][0];
    }
    this.cdref.detectChanges();
  }

  clearDate(index: number): void {
    switch (index) {
      case 1:
        this.AdoptedDate = null;
        this.form194.get('main')?.get('AdoptedDate')?.setValue(null);
        this.form194.get('main')?.get('AdoptedDate')?.markAsTouched();
        break;
      default:
        break;
    }
    console.log('🔄 First detectChanges() called for index:', index);
    this.cdref.detectChanges();
    
    // Additional clearing step to ensure ap-date-picker component updates
    setTimeout(() => {
      // 🚀 CRITICAL: Force clear date picker input fields if they still show values
      this.forceClearDatePickerInputs(index);
    }, 0);
  }

  /**
   * 🚀 CRITICAL: Force clear date picker input fields using DOM manipulation
   * This is a fallback method for stubborn date picker components
   */
  private forceClearDatePickerInputs(index: number): void {
    try {
      // Find the date picker input field by form control name
      const formControlNames = ['AdoptedDate'];
      const formControlName = formControlNames[index - 1];
      
      if (formControlName) {
        // Try to find the input field within the date picker component
        const datePickerElement = document.querySelector(`[formcontrolname="${formControlName}"]`);
        if (datePickerElement) {
          const inputElement = datePickerElement.querySelector('input');
          if (inputElement && inputElement.value) {
            // Clear the input value and trigger change event
            inputElement.value = '';
            inputElement.dispatchEvent(new Event('input', { bubbles: true }));
            inputElement.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    } catch (error) {
      console.warn('Error clearing date picker input:', error);
    }
  }

  dateChange(event: any, index: number) {
    switch (index) {
      case 1:
        this.AdoptedDate = event.startDate.format('YYYY-MM-DD');

        const leids: string = this.sharedService.concatLEIDs([this.transferee!, this.transferor!]);
        if (!leids) {
          break;
        }
        this.startLoader = true;
        this.entityNameChangeOnDate = true;
        this.sharedService.checkForEntityNameChange(this.statementId,
          leids,
          this.sharedService.getTransDateStr(this.AdoptedDate, 1),
          this.sharedService.getActiveFormState().taxYear.toString()
        ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: EntityNameChange[]) => {
          if (response) {
            for (let i = 0; i < leids.split(',').length; i++) {
              this.sharedService.updateEntityName(response[i].LEID,
                response[i].LE_NAME, [this.transferee!, this.transferor!], response[i].TAXTYPECODE);
            }
          }
          this.nameChangeChecked = true;
        }, (error: HttpErrorResponse) => {
          console.log(error);
          this.dstSharedService.showAlert('error', error.message);
        }).add(() => {
          this.startLoader = false;
        });
        break;
    }
  }

  onTransferorChanged(selectedTransferor: DSTEntityDetails | null): void {
    this.transferor = selectedTransferor;
    this.headerComponent.loadConsolGroups(selectedTransferor?.LEID!,this.dcnId);
    if (this.AdoptedDate && this.transferor?.LEID) {
      this.startLoader = true;
      this.entityNameChangeOnDate = true;
      this.sharedService.checkForEntityNameChange(this.statementId,
        this.transferor.LEID,
        this.sharedService.getTransDateStr(this.AdoptedDate, 1),
        this.sharedService.getActiveFormState().taxYear.toString()
      ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: EntityNameChange[]) => {
        if (response && response[0]) {
          (response[0].LE_NAME) && (this.transferor!.ENTITY = response[0].LE_NAME); // override entity name
          this.transferor!.TAXTYPECODE = response[0]?.TAXTYPECODE!; //override entity type
        }
          this.nameChangeChecked = true;
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.dstSharedService.showAlert('error', error.message);
      }).add(() => {
        this.startLoader = false;
      });
    }else if(!this.AdoptedDate) {
      this.nameChangeChecked = true;

    }  else {
      this.entityNameChangeOnDate = false;
    }

    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.transferor!, this.transferee!]);
    this.showDREMsg = !!this.DREMsg;
  }

  onTransfereeChanged(selectedTransferor: DSTEntityDetails | null): void {
    this.transferee = selectedTransferor;
    if (this.AdoptedDate && this.transferee?.LEID) {
      this.startLoader = true;
      this.entityNameChangeOnDate = true;
      this.sharedService.checkForEntityNameChange(this.statementId,
        this.transferee.LEID,
        this.sharedService.getTransDateStr(this.AdoptedDate, 1),
        this.sharedService.getActiveFormState().taxYear.toString()
      ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: EntityNameChange[]) => {
        if (response && response[0]) {
          (response[0].LE_NAME) && (this.transferee!.ENTITY = response[0].LE_NAME); // override entity name
          this.transferee!.TAXTYPECODE = response[0]?.TAXTYPECODE!; //override entity type
        }
          this.nameChangeChecked = true;
      }, (error: HttpErrorResponse) => {
        console.log(error);
        this.dstSharedService.showAlert('error', error.message);
      }).add(() => {
        this.startLoader = false;
      });
    }else if(!this.AdoptedDate) {
      this.nameChangeChecked = true;

    }  else {
      this.entityNameChangeOnDate = false;
    }

    this.DREMsg = this.sharedService.areEntitiesDisregarded([this.transferee!, this.transferor!]);
    this.showDREMsg = !!this.DREMsg;
  }

  onFormOptionChanged(selectedOptionID: Event): void {
    this.selectedOptionID = selectedOptionID;
  }

  OnConsolGroupChanged(consolGroup: DSTConsolGroup): void {
    this.dcnId = consolGroup.DCNID;
  }

  onBranchEntityChanged(selectedBranch: DSTEntityDetails | null): void {
    this.branchEntity = selectedBranch;
  }

  save(): void {
    const trackerTab: TrackerTabState | null = this.trackerTabsService.getActiveTrackerTab();
    if (!trackerTab) {
      return;
    }
    const isPlaceholderChecked: boolean = trackerTab.isPlaceholderChecked;
    if (!this.isFormValid(isPlaceholderChecked) || !this.sharedService.confirmDRE([this.transferee, this.transferor])) {
      return;
    } else {
      this.startLoader = true;
      const formState: DSTFormState = this.sharedService.getActiveFormState();
      const params: { [param: string]: string } = {
        'statementID': this.statementId !== '' ? this.statementId : '0',
        'taxYear': formState.taxYear.toString(),
        'taxYearId': formState.taxYearId.toString(),
        'dcnId': this.dcnId ? toSaveString(this.dcnId) : '',
        'returnPeriodId': formState.returnPeriodId.toString(),
        'formId': formState.formId.toString(),
        'primaryEntityId': safeEntityId(this.transferor),
        'secondaryEntityId': safeEntityId(this.transferee),
        'branchEntityId': safeEntityId(this.branchEntity),
        'comments': '',
        'placeHolder': isPlaceholderChecked ? '1' : '0',
        'csStatementId': formState.csStatementId?.toString() || '0',
        'attachmentFileName': '',
      };
      const jsonObject = {
        'AdoptedDate': this.AdoptedDate !== null && this.AdoptedDate !== '' ? this.AdoptedDate.startDate ? this.AdoptedDate.startDate.format('YYYY-MM-DD') : this.AdoptedDate : '',
        'f367bOwnedPct': this.OwnedPctVal !== null && this.OwnedPctVal !== undefined ? toSaveString(this.OwnedPctVal) : '',
      };
      this.sharedService.saveStatemenet(params, jsonObject).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
        if (data) {
          this.dstSharedService.showAlert('success', 'Form Save Success!');
          this.startLoader = false;
          this.sharedService.setSavedStatementId(data.statementId);
          this.sharedService.switchTemplateMode(true);
          this.onSave.emit(); // emit without payload -- only notifies tracker to refresh grid
        }
      }, () => {
        this.dstSharedService.showAlert('error', 'Error!');
        this.startLoader = false;
      });
    }

  }

  isFormValid(placeholder: boolean): boolean {
    if (placeholder) {
      if (!this.transferor) {
        this.dstSharedService.showAlert('error', 'Please specify a LEID of Transferor');
        return false;
      }
    } else {
      if (!this.transferee) {
        this.dstSharedService.showAlert('error', 'Please specify a LEID of Transferee');
        return false;
      }
      if (!this.transferor) {
        this.dstSharedService.showAlert('error', 'Please specify a LEID of Transferor');
        return false;
      }
      if(this.sharedService.getActiveFormState()?.taxYear >= 2023 && !this.OwnedPctVal){
        this.dstSharedService.showAlert('error', 'Please specify the percentage of Capital stock');
        return false;
      }
    }

    return true;
  }

  clear(): void {
    if (this.statementId !== '' && this.statementId !== '0') {
      this.sharedService.switchTemplateMode(true);
    } else {
      this.onCancel.emit();
    }
  }

  onDPOpen(): void { // styling fix for gtw-ui
    const modalEle: Element | null = document.querySelector('ngx-daterangepicker-material');
    modalEle?.classList.add('gtw-web-components');
  }
}


